import React from "react";

export default function DownloadCSV({closeToast }) {
  const handleClose = () => {
    closeToast();
  };

  return (
    <div>
      <div className="">
        <div id="">
          <div id="">
            <p className="popUpText">Your csv file has been downloaded.</p>
            <button className="alert_button" onClick={handleClose}>
              OK
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
